import React from 'react';

import type { IStoreRankDetailsCoreContext } from './types';

const defaultContext: IStoreRankDetailsCoreContext = {
  showRankName: false,
  countries: [],
  fetchCountriesRankData: () => Promise.resolve([]),
  entityType: '',
  gameName: '',
  gameCover: '',
  dateType: '',
  startDate: '',
  endDate: '',
};

export const StoreRankDetailsCoreContext = React.createContext<IStoreRankDetailsCoreContext>(defaultContext);
